import { CovidData } from './store'

export const store = new CovidData()